

















































import { i18n } from '@/i18n';
import { compass } from '@resclick/compass';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

@Component
export default class OrderDocumentsModal extends Vue {
  @PropSync('open') openSync!: boolean;
  @Prop({ type: String }) id!: string;
  loading = false;

  content = '';
  iframeHeight = 0;

  onIframeLoad() {
    this.iframeHeight = (this.$refs as any).iframe.contentWindow.document.body.scrollHeight;
  }

  @Watch('open')
  onOpen(value: boolean) {
    if (value && this.id) {
      this.loading = true;
      compass
        .do('orders', 'renderDocument', {
          params: {
            orderId: this.id,
            documentId: this.id,
          },
          lang: i18n.locale,
        })
        .then((res) => (this.content = res.data))
        .finally(() => (this.loading = false));
    } else {
      this.content = '';
    }
  }

  sendEmail() {
    this.loading = true;
    compass
      .do('orders', 'sendDocumentByEmail', {
        params: {
          orderId: this.id,
          documentId: this.id,
        },
      })
      .then(() => {
        this.$q.notify({
          message: i18n.t('MESSAGE.OPERATION_SUCCESSFUL') as string,
          color: 'positive',
        });
      })
      .catch(() => {
        this.$q.notify({
          message: i18n.t('MESSAGE.OPERATION_FAIL') as string,
          color: 'negative',
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  printDocument() {
    (this.$refs as any).iframe.contentWindow.print();
  }
}
